exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui-image---status{background-color:#f8f8f9;border-radius:6px;overflow:hidden}.ui-image---status,.ui-image---status .ui-image-fail{position:absolute;top:0;left:0;width:100%;height:100%}.ui-image---status .ui-image-fail{background:#f8f8f9 url(" + require("!!url-loader!../img/img-fail.png") + ") 50%/47px 62px no-repeat}.ui-image---status .ui-image-loading{position:absolute;left:0;top:0;width:100%;height:100%;background:#f8f8f9 url(" + require("!!url-loader!../img/img-loading.png") + ") 50%/47px 62px no-repeat}.ui-image---status .ui-image-blocked{position:absolute;left:0;top:0;width:100%;height:100%;z-index:2;background:#f8f8f9 url(" + require("!!url-loader!../img/img-blocked.png") + ") 50%/86px 73px no-repeat}.ui-image---status .ui-image-img{position:absolute;left:0;top:0;margin:0;padding:0;width:100%!important;height:100%!important;border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/ui/image/scss/status.scss
// module id = 670
// module chunks = 0 1 2 3